module.exports = new __parcel__URL__("../../woman-at-laptop-computer.10a82aa3.png").toString();